import React, { useRef } from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { getUserCourseLisenceAPI } from '../../Api/ClientServices'
import ReactLoading from 'react-loading';
import LisenceHolder from '../LisenceHolder/LisenceHolder';


const CourseLisence = () => {
    const[lisence,setLisence]=useState()

    useEffect(()=>{
        getCourseLisence()
    },[])
    const getCourseLisence =async()=>{
        const data=await getUserCourseLisenceAPI()
        setLisence(data.course)
    }


    let loadingHandler=null
    if(lisence===undefined){
        loadingHandler=<div className='w-100 d-flex align-items-center justify-content-center'>
        <ReactLoading type={'cylon'} color={'#096CCC'} />
      </div>
    }
    else if(lisence.length===0){
        loadingHandler=<p className='w-100 p-2 bg-warning text-center'>شما دوره ای نخریده اید</p>
    }
    else{
        loadingHandler=lisence.map(item=>{
            return(
                <LisenceHolder key={item.id} item={item}/>
            )
        })
    }
    return (
        <section className='pageHolder'>
           {
               loadingHandler
           }
        </section>
    )
}

export default CourseLisence
